import type { Step } from "react-joyride";

export const documentsHubTourSteps: Step[] = [
  {
    target: "body",
    content: "ນີ້ແມ່ນສູນກາງເອກະສານ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="doc-hub-cards-grid"]',
    content: "ເລືອກຫມວດເອກະສານທີ່ຕ້ອງການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="doc-hub-recent"]',
    content: "ລາຍການເອກະສານທີ່ອັບເດດຫນ້າສຸດ.",
    placement: "top",
  },
];

export const formsCenterTourSteps: Step[] = [
  {
    target: "body",
    content: "ໜ້າສູນກາງແບບຟອມ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="doc-forms-filters"]',
    content: "ໃຊ້ຕົວກອງ ແລະ ຄົ້ນຫາແບບຟອມ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="doc-forms-grid"]',
    content: "ກົດບັດເພື່ອເປີດລາຍລະອຽດແບບຟອມ.",
    placement: "top",
  },
];

export const formDetailTourSteps: Step[] = [
  {
    target: "body",
    content: "ລາຍລະອຽດແບບຟອມ ແລະ ການສົ່ງຟອມ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="doc-form-detail-content"]',
    content: "ອ່ານຂໍ້ມູນ ແລະ ຕົວຢ່າງແບບຟອມ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="doc-form-detail-submit"]',
    content: "ກອກຂໍ້ມູນແລ້ວກົດສົ່ງ.",
    placement: "top",
  },
];

export const templatesCenterTourSteps: Step[] = [
  {
    target: "body",
    content: "ໜ້າແມ່ແບບເອກະສານ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="doc-templates-filters"]',
    content: "ກອງຕາມແຜນການ ແລະ ຄົ້ນຫາ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="doc-templates-grid"]',
    content: "ກົດດາວໂຫລດໄຟລ໌ແມ່ແບບ.",
    placement: "top",
  },
];

export const contractsTourSteps: Step[] = [
  {
    target: '[data-tourid="doc-contracts-grid"]',
    content: "ເບິ່ງ ຫຼື ດາວໂຫລດສັນຍາໄດ້ຈາກບັດ.",
    placement: "top",
  },
];

export const contractDetailTourSteps: Step[] = [
  {
    target: '[data-tourid="doc-contract-detail-content"]',
    content: "ກວດເບິ່ງຂໍ້ມູນສຳຄັນ ແລະ ເງື່ອນໄຂ.",
    placement: "top",
  },
];

export const policiesTourSteps: Step[] = [
  {
    target: '[data-tourid="doc-policies-grid"]',
    content: "ກົດເບິ່ງນະໂຍບາຍແຕ່ລະອັນ.",
    placement: "top",
  },
];

export const policyDetailTourSteps: Step[] = [
  {
    target: '[data-tourid="doc-policy-detail-content"]',
    content: "ເນື້ອໃນນະໂຍບາຍທັງໝົດຢູ່ສ່ວນນີ້.",
    placement: "top",
  },
];
